<template>
	<div>
		<CModal title="Liste des règlements" size="lg" :show.sync="showModal">
			<GDataTableRemote
				ref="mainTable"
				:remote-url="`/api/pos_invoice_payments?invoice=${this.posInvoice.id}`"
				:fields="fields"
				:items-per-page="10"
				class="mt-4"
				hover
				striped
				sorter
				columnFilter
				pagination>
				<template #amount="{ item }">
					<td>
						{{ $numeral(item.amount).format('0,0.00 $') }}
					</td>
				</template>

				<template #method="{ item }">
					<td>
						{{ paymentMethodTranslation[item.method] }}
					</td>
				</template>

				<template #actions="{ item }">
					<td class="text-center">
						<a class="icon-action" href="#" @click.prevent="removePayment(item)">
							<CIcon name="cil-trash" />
						</a>
					</td>
				</template>
			</GDataTableRemote>

			<template #footer>
				<CButton color="success" v-on:click="addPayment()">Ajouter un règlement</CButton>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
			</template>
		</CModal>

		<payment-add-modal ref="paymentAddModal" v-on:refresh="refresh" />
	</div>
</template>

<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	import PaymentAddModal from './payment-add-modal';
	export default {
		name: 'payments-history-modal',
		components: { PaymentAddModal, GDataTableRemote },
		data() {
			return {
				showModal: false,
				posInvoice: {},
				fields: [
					{ key: 'id', label: 'ID' },
					{ key: 'amount', label: 'Montant' },
					{ key: 'method', label: 'Méthode de paiement' },
					{ key: 'info', label: 'Infos système' },
					{ key: 'additionalInfo', label: 'Commentaire(s)' },
					{ key: 'actions', label: 'Actions', filter: false },
				],
				paymentMethodTranslation: {
					'pos_invoice_payment.cash': 'Espèce',
					'pos_invoice_payment.check': 'Chèque',
					'pos_invoice_payment.bank_transfer': 'Virement bancaire',
					'pos_invoice_payment.direct_debit': 'Prélèvement bancaire',
				},
			};
		},

		methods: {
			addPayment() {
				this.$refs.paymentAddModal.posInvoice = this.posInvoice;
				this.$refs.paymentAddModal.showModal = true;
			},

			removePayment(item) {
				this.$axios.delete(item['@id']).then(() => {
					this.$refs.mainTable.refresh();
					this.$emit('refresh');
				});
			},

			refresh() {
				this.$refs.mainTable.refresh();
				this.$emit('refresh');
			},
		},
	};
</script>
